import {EventEmitter, Injectable} from '@angular/core';
import {MatchStatus} from './match.service';
import {environment} from 'environments/environment';

@Injectable()
export class ContextService {
  private matchId: number;
  private quarter = MatchStatus.Finished;
  private live = false;
  private match: any;
  private events: any[];

  private contextChangedSource = new EventEmitter<any>();
  contextChanged$ = this.contextChangedSource.asObservable();

  constructor() {
  }

  get defaultTeamImg() {
    return `${environment.teamAssetsUrl}/default/badge.png`;
  }

  setMatchId(matchId: number) {
    this.matchId = matchId;
    this.propagateChanges();
  }

  getMatchId(): number {
    return this.matchId;
  }

  setQuarter(quarter: number) {
    this.quarter = quarter;
    this.propagateChanges();
  }

  getQuarter(): number {
    return this.quarter;
  }

  isLive(): boolean {
    return this.live;
  }

  setLive(live: boolean) {
    this.live = live;
    this.propagateChanges();
  }

  propagateChanges() {
    this.contextChangedSource.next({
      matchId: this.matchId,
      quarter: this.quarter,
      live: this.live
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/services/context.service.ts